import * as zod from 'zod'

const chargeAfterMinutesSchema = zod.coerce
  .number({
    required_error: 'Charge after minutes is required',
    invalid_type_error: 'Charge after minutes is required',
  })
  .int({ message: 'Charge after minutes must be a whole number' })
  .min(0, { message: 'Charge after minutes must be 0 or greater' })

export const createCushionChargePolicySchema = zod.object({
  chargeAfterMinutes: chargeAfterMinutesSchema,
  startsAt: zod
    .string({ required_error: 'Start time is required' })
    .min(1, 'Start time is required')
    .refine(
      (value) => value === '' || !Number.isNaN(new Date(value).getTime()),
      {
        message: 'Start time must be a valid date',
      }
    ),
})

export type CreateCushionChargePolicySchema = zod.infer<
  typeof createCushionChargePolicySchema
>

export const editCushionChargePolicySchema = zod.object({
  chargeAfterMinutes: chargeAfterMinutesSchema,
})

export type EditCushionChargePolicySchema = zod.infer<
  typeof editCushionChargePolicySchema
>
